module.exports = __webpack_public_path__ + "static/media/wf.7bfea759.svg";